import React, { useEffect, useContext, useState } from "react";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import ChartsHandler from "../../../../components/Charts/ChartsHandler.tsx";
import "./TerceiroDashboard.css";
import { Card } from "primereact/card";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import { motion } from "framer-motion";
import { getDashEmbarque2Search } from "../../../../services/ModuloGerenciador/Search.js";
import FiltrosRedux from "../../../../contexts/Filtros.js";
import iconeImprimir from "../../../../images/iconeImprimir.png";
import iconeProximo from "../../../../images/iconeProximo.png";
import iconeAnterior from "../../../../images/iconeAnterior.png";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2.js";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";

function TerceiroDashboard() {
	const { profile, hasRegra, contextoEmbarque } = useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const { filtrosRedux, setFiltrosRedux } = useContext(FiltrosRedux);

	const [values, setValues] = useState({});

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [openToastErro, setOpenToastErro] = useState(false);

	const [textoErro, setTextoErro] = useState("");

	const [dadosGrafico6, setDadosGrafico6] = useState([]);

	const [dadosGrafico1, setDadosGrafico1] = useState([]);

	const [dadosGrafico3, setDadosGrafico3] = useState([]);

	const [dadosGrafico2, setDadosGrafico2] = useState([]);

	const [dadosGrafico4, setDadosGrafico4] = useState([]);

	const [dadosGrafico5, setDadosGrafico5] = useState([]);

	const [loading, setLoading] = useState(true);

	const navigate = useNavigate();

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	useEffect(() => {
		var date = new Date();
		var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
		var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		setValues({
			contexto: "todos",
			dataInicio: primeiroDia,
			dataFinal: ultimoDia,
		});
	}, []);

	const imprimir = () => {
		window.print();
	};

	const proxPage = () => {
		navigate("/quarto-dashboard");
		localStorage.setItem("flagPaginando", "true");
	};

	const voltarPage = () => {
		navigate("/segundo-dashboard");
		localStorage.setItem("flagPaginando", "true");
	};

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (!profile) return;
		setSemAutorizacao(!hasRegra("Dashboard"));
	});

	const converterData = (data) => {
		const parts = data.split("-");
		return `${parts[2]}-${parts[1]}-${parts[0]}`;
	};

	const buscarDadosDashboard2 = async () => {
		setLoading(true);
		var date = new Date();
		var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
			.toLocaleDateString("pt-BR", {
				year: "numeric",
				month: "numeric",
				day: "numeric",
			})
			.replace(/\//g, "-");
		var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0)
			.toLocaleDateString("pt-BR", {
				year: "numeric",
				month: "numeric",
				day: "numeric",
			})
			.replace(/\//g, "-");
		const data1 = converterData(primeiroDia);
		const data2 = converterData(ultimoDia);
		if (
			(Array.isArray(filtrosRedux) && filtrosRedux.length !== 0) ||
			(filtrosRedux &&
				Object.keys(filtrosRedux).length !== 0 &&
				filtrosRedux.constructor === Object)
		) {
			const pesquisaFormatada = `${filtrosRedux.item}=${filtrosRedux.pesquisa}`;
			await getDashEmbarque2Search(
				profile?.token,
				pesquisaFormatada,
				filtrosRedux.contexto ? filtrosRedux.contexto : "todos",
				filtrosRedux.embarqueInicio ? filtrosRedux.embarqueInicio : data1,
				filtrosRedux.embarqueFinal ? filtrosRedux.embarqueFinal : data2
			)
				.then((result) => {
					if (result.data.pagina.grafico1.pizza === null) {
						setDadosGrafico1(result.data.pagina.grafico1.pizzaDouble);
					}
					if (result.data.pagina.grafico1.pizzaDouble === null) {
						setDadosGrafico1(result.data.pagina.grafico1.pizza);
					}
					setDadosGrafico2(result.data.pagina.grafico2.barra);
					if (result.data.pagina.grafico3.pizza === null) {
						setDadosGrafico3(result.data.pagina.grafico3.pizzaDouble);
					}
					if (result.data.pagina.grafico3.pizzaDouble === null) {
						setDadosGrafico3(result.data.pagina.grafico3.pizza);
					}
					if (result.data.pagina.grafico4.pizza === null) {
						setDadosGrafico4(result.data.pagina.grafico4.pizzaDouble);
					}
					if (result.data.pagina.grafico4.pizzaDouble === null) {
						setDadosGrafico4(result.data.pagina.grafico4.pizza);
					}
					if (result.data.pagina.grafico5.pizza === null) {
						setDadosGrafico5(result.data.pagina.grafico5.pizzaDouble);
					}
					if (result.data.pagina.grafico5.pizzaDouble === null) {
						setDadosGrafico5(result.data.pagina.grafico5.pizza);
					}
					setDadosGrafico6(result.data.pagina.grafico6.barra);
					setLoading(false);
				})
				.catch((error) => {
					if (error.response.status !== 200) {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					} else {
						setTextoErro(error.response.data);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			await getDashEmbarque2Search(
				profile?.token,
				"undefined=undefined",
				"todos",
				data1,
				data2
			)
				.then((result) => {
					if (result.data.pagina.grafico1.pizza === null) {
						setDadosGrafico1(result.data.pagina.grafico1.pizzaDouble);
					}
					if (result.data.pagina.grafico1.pizzaDouble === null) {
						setDadosGrafico1(result.data.pagina.grafico1.pizza);
					}
					setDadosGrafico2(result.data.pagina.grafico2.barra);
					if (result.data.pagina.grafico3.pizza === null) {
						setDadosGrafico3(result.data.pagina.grafico3.pizzaDouble);
					}
					if (result.data.pagina.grafico3.pizzaDouble === null) {
						setDadosGrafico3(result.data.pagina.grafico3.pizza);
					}
					if (result.data.pagina.grafico4.pizza === null) {
						setDadosGrafico4(result.data.pagina.grafico4.pizzaDouble);
					}
					if (result.data.pagina.grafico4.pizzaDouble === null) {
						setDadosGrafico4(result.data.pagina.grafico4.pizza);
					}
					if (result.data.pagina.grafico5.pizza === null) {
						setDadosGrafico5(result.data.pagina.grafico5.pizzaDouble);
					}
					if (result.data.pagina.grafico5.pizzaDouble === null) {
						setDadosGrafico5(result.data.pagina.grafico5.pizza);
					}
					setDadosGrafico6(result.data.pagina.grafico6.barra);
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		}
	};

	const itensFiltro = [
		{
			nomeColuna: "Tipo Carroceria",
			field: "tipoCarroceria",
		},
		{
			nomeColuna: "Descrição",
			field: "descricao",
		},
		{
			nomeColuna: "Empresa",
			field: "empresa",
		},
		{
			nomeColuna: "Filial",
			field: "filial",
		},
		{
			nomeColuna: "Unidade de Embarque",
			field: "unidEmbarque",
		},
		{
			nomeColuna: "Cidade Origem",
			field: "cidadeOrigem",
		},
		{
			nomeColuna: "Estado Origem",
			field: "estadoOrigem",
		},
		{
			nomeColuna: "Cidade Destino",
			field: "cidadeDestino",
		},
		{
			nomeColuna: "Estado Destino",
			field: "estadoDestino",
		},
		{
			nomeColuna: "Pedido",
			field: "pedido",
		},
		{
			nomeColuna: "CTE",
			field: "cte",
		},
		{
			nomeColuna: "Previsão Viagem",
			field: "previsaoEmbarque",
		},
		{
			nomeColuna: "Data Viagem",
			field: "dataEmbarque",
		},
		{
			nomeColuna: "Previsão Entrega",
			field: "previsaoEntrega",
		},
		{
			nomeColuna: "Data Entrega",
			field: "dataEntrega",
		},
		{
			nomeColuna: "Data Hora Chegada Viagem",
			field: "dataHoraChegadaEmbarque",
		},
		{
			nomeColuna: "Data Hora Chegada Entrega",
			field: "dataHoraChegadaEntrega",
		},
		{
			nomeColuna: "Data Hora Entregue",
			field: "dataHoraEntregue",
		},
		{
			nomeColuna: "Data Hora Embarcado",
			field: "dataHoraEmbarcado",
		},
		{
			nomeColuna: "Aceite",
			field: "aceite",
		},
		{
			nomeColuna: "Status",
			field: "status",
		},
		{
			nomeColuna: "Placa Cavalo",
			field: "placaCavalo",
		},
		{
			nomeColuna: "Placa Carreta",
			field: "placaCarreta",
		},
		{
			nomeColuna: "Placa Segunda Carreta",
			field: "placaCarreta2",
		},
		{
			nomeColuna: "Proprietario",
			field: "proprietario",
		},
		{
			nomeColuna: "Motorista",
			field: "veiculoMotorista",
		},
		{
			nomeColuna: "ICMS",
			field: "icms",
		},
		{
			nomeColuna: "Frete Motorista",
			field: "freteMotorista",
			tipo: "number",
		},
		{
			nomeColuna: "Frete Fiscal",
			field: "freteFiscal",
			tipo: "number",
		},
		{
			nomeColuna: "Adicional Empresa",
			field: "adicionalEmpresa",
			tipo: "number",
		},
		{
			nomeColuna: "Adicional Motorista",
			field: "adicionalMotorista",
			tipo: "number",
		},
		{
			nomeColuna: "Pedagio",
			field: "pedagio",
			tipo: "number",
		},
		{
			nomeColuna: "Classificação",
			field: "classificacao",
			tipo: "number",
		},
		{
			nomeColuna: "Margem",
			field: "margem",
		},
		{
			nomeColuna: "Adiantamento",
			field: "adiantamento",
			tipo: "number",
		},
		{
			nomeColuna: "Saldo",
			field: "saldo",
			tipo: "number",
		},
		{
			nomeColuna: "Meio Pagamento",
			field: "meioPagamento",
		},
		{
			nomeColuna: "Meio Pagamento Dois",
			field: "meioPagamento2",
		},
		{
			nomeColuna: "Km",
			field: "km",
			tipo: "number",
		},
		{
			nomeColuna: "Cliente",
			field: "cliente",
		},
		{
			nomeColuna: "Embarcador",
			field: "embarcador",
		},
		{
			nomeColuna: "Destinatario",
			field: "destinatario",
		},
		{
			nomeColuna: "LOAD",
			field: "load",
		},
		{
			nomeColuna: "Mercadoria",
			field: "mercadoria",
		},
		{
			nomeColuna: "Peso",
			field: "peso",
			tipo: "number",
		},
		{
			nomeColuna: "Embalagem",
			field: "embalagem",
		},
		{
			nomeColuna: "Observação",
			field: "observacao",
		},
		{
			nomeColuna: "Frota",
			field: "frota",
		},
		{
			nomeColuna: "Cancelado",
			field: "cancelado",
		},
		{
			nomeColuna: "Motivo",
			field: "motivo",
		},
	];

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		buscarSearchReset();
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getDashEmbarque2Search(
			profile?.token,
			pesquisaFormatada,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				if (result.data.pagina.grafico1.pizza === null) {
					setDadosGrafico1(result.data.pagina.grafico1.pizzaDouble);
				}
				if (result.data.pagina.grafico1.pizzaDouble === null) {
					setDadosGrafico1(result.data.pagina.grafico1.pizza);
				}
				setDadosGrafico2(result.data.pagina.grafico2.barra);
				if (result.data.pagina.grafico3.pizza === null) {
					setDadosGrafico3(result.data.pagina.grafico3.pizzaDouble);
				}
				if (result.data.pagina.grafico3.pizzaDouble === null) {
					setDadosGrafico3(result.data.pagina.grafico3.pizza);
				}
				if (result.data.pagina.grafico4.pizza === null) {
					setDadosGrafico4(result.data.pagina.grafico4.pizzaDouble);
				}
				if (result.data.pagina.grafico4.pizzaDouble === null) {
					setDadosGrafico4(result.data.pagina.grafico4.pizza);
				}
				if (result.data.pagina.grafico5.pizza === null) {
					setDadosGrafico5(result.data.pagina.grafico5.pizzaDouble);
				}
				if (result.data.pagina.grafico5.pizzaDouble === null) {
					setDadosGrafico5(result.data.pagina.grafico5.pizza);
				}
				setDadosGrafico6(result.data.pagina.grafico6.barra);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarSearchReset = async () => {
		setLoading(true);
		const pesquisaFormatada = "undefined=undefined";
		await getDashEmbarque2Search(
			profile?.token,
			pesquisaFormatada,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal
		)
			.then((result) => {
				if (result.data.pagina.grafico1.pizza === null) {
					setDadosGrafico1(result.data.pagina.grafico1.pizzaDouble);
				}
				if (result.data.pagina.grafico1.pizzaDouble === null) {
					setDadosGrafico1(result.data.pagina.grafico1.pizza);
				}
				setDadosGrafico2(result.data.pagina.grafico2.barra);
				if (result.data.pagina.grafico3.pizza === null) {
					setDadosGrafico3(result.data.pagina.grafico3.pizzaDouble);
				}
				if (result.data.pagina.grafico3.pizzaDouble === null) {
					setDadosGrafico3(result.data.pagina.grafico3.pizza);
				}
				if (result.data.pagina.grafico4.pizza === null) {
					setDadosGrafico4(result.data.pagina.grafico4.pizzaDouble);
				}
				if (result.data.pagina.grafico4.pizzaDouble === null) {
					setDadosGrafico4(result.data.pagina.grafico4.pizza);
				}
				if (result.data.pagina.grafico5.pizza === null) {
					setDadosGrafico5(result.data.pagina.grafico5.pizzaDouble);
				}
				if (result.data.pagina.grafico5.pizzaDouble === null) {
					setDadosGrafico5(result.data.pagina.grafico5.pizza);
				}
				setDadosGrafico6(result.data.pagina.grafico6.barra);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	useEffect(() => {
		if (valuesPesquisa.contexto !== undefined) {
			buscarSearch();
		}
	}, [valuesPesquisa.contexto]);

	const location = useLocation();

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname, contextoEmbarque]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<NavbarV3 title="Viagens BRF" selecionado="Dashboard" />
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					<NavbarV3 title="Viagens BRF" selecionado="Dashboard" />
					<div className="dashboards">
						<div className="header-dashboard1">
							<div className="flex2">
								<p className="indicador-principal-faturamento-v2"></p>
								<img
									onClick={imprimir}
									className="imagens-faturamentos"
									src={iconeImprimir}
								/>
							</div>
						</div>
						<div className="containerBuscas1">
							<div className="filtro-embarque">
								{
									<FiltroV2
										classe="div-filtrar-faturamento-v2"
										classOption="select-options"
										itensFiltro={itensFiltro}
										valuesPesquisa={valuesPesquisa}
										setValuesPesquisa={setValuesPesquisa}
										buscarSearch={buscarSearch}
										limpar={limpar}
									/>
								}
							</div>
							<div>
								<img
									onClick={voltarPage}
									className="imagens-faturamentos"
									src={iconeAnterior}
								/>
								<img
									onClick={proxPage}
									className="imagens-faturamentos"
									src={iconeProximo}
								/>
							</div>
						</div>
						<div className="charts">
							{!loading ? (
								<div>
									<div className="graficosCimaSegundo">
										<div className="item">
											<Card>
												<ChartsHandler
													data={dadosGrafico5}
													type={"pie"}
													height="auto"
													width={570}
												/>
											</Card>
										</div>
										<div className="item">
											<Card>
												<ChartsHandler
													data={dadosGrafico6}
													type={"bar"}
													height="auto"
													width={570}
												/>
											</Card>
										</div>
										<div className="item">
											<Card>
												<ChartsHandler
													data={dadosGrafico1}
													type={"pie"}
													height="auto"
													width={570}
												/>
											</Card>
										</div>
										<div className="item">
											<Card>
												<ChartsHandler
													data={dadosGrafico2}
													type={"bar"}
													height="auto"
													width={570}
												/>
											</Card>
										</div>
										<div className="item">
											<Card>
												<ChartsHandler
													data={dadosGrafico3}
													type={"pie"}
													height="auto"
													width={570}
												/>
											</Card>
										</div>
										<div className="item">
											<Card>
												<ChartsHandler
													data={dadosGrafico4}
													type={"pie"}
													height="auto"
													width={570}
												/>
											</Card>
										</div>
									</div>
									<br></br>
									<br></br>
								</div>
							) : (
								<LoadingComponent />
							)}
						</div>
					</div>
					<ToastSucesso
						texto={textoSucesso}
						open={openToastSucesso}
						onClose={handleCloseToastSucesso}
					/>
					<ToastErro
						texto={textoErro}
						open={openToastErro}
						onClose={handleCloseToastErro}
					/>
				</div>
			)}
		</motion.div>
	);
}

export default TerceiroDashboard;
